__turbopack_context__.v({
  "className": "inter_23ac817e-module__eRlGyW__className",
  "variable": "inter_23ac817e-module__eRlGyW__variable",
});
